import Database from '@/services/offline/database.js'

class OperatorCache extends Database {

  constructor() {
    super()
  }

  _storeName() {
    return 'operators'
  }

  /**
   * @param {Object} param - Cache parameters
   * @param {Object[]} param.operators - Operators to cache
   */
  async cache({ operators }) {
    let storageKey = this._createStorageKey()

    const db = await this.dbPromise
    await db.put(this._storeName(), operators, storageKey)
  }

  async get() {
    let storageKey = this._createStorageKey()

    const db = await this.dbPromise
    return await db.get(this._storeName(), storageKey)
  }

  async cachePresent() {
    return !!(await this.get())
  }

  async deleteAllCache() {
    const db = await this.dbPromise
    return await db.clear(this._storeName())
  }

  _createStorageKey() {
    return 'operators'
  }
}

export default new OperatorCache()